import { defineStore } from 'pinia'
import apiService, { API_ROOT } from '@/services/apiService'

export const useAddonForModelStore = defineStore('addonForModelStore', {
  state: () => ({
    addonsForModels: [],
    addons: [],
    trailers: [],
    loading: false,
    error: null,
  }),

  actions: {
    async fetchAll() {
      this.loading = true
      this.error = null
      try {
        const [afmRes, addonsRes, trailersRes] = await Promise.all([
          apiService.get('/addons-for-model'),
          apiService.get('/addons'),
          apiService.get('/trailers'),
        ])

        this.addonsForModels = afmRes.data
        this.addons = addonsRes.data.map(addon => ({
          ...addon,
          image_url: addon.image ? `${API_ROOT}/storage/${addon.image}` : ''
        }))
        this.trailers = trailersRes.data
      } catch (err) {
        this.error = err
        console.error('Błąd przy pobieraniu dodatków dla modeli:', err)
      } finally {
        this.loading = false
      }
    },

    async storeAddonForModel(data) {
      this.loading = true
      this.error = null
      try {
        const response = await apiService.post('/addons-for-model', data)
        this.addonsForModels.push(response.data)
        return response.data
      } catch (err) {
        this.error = err
        throw err
      } finally {
        this.loading = false
      }
    },

    async updateAddonForModel(id, data) {
      this.loading = true
      this.error = null
      try {
        const response = await apiService.post(`/addons-for-model/${id}`, data)
        const index = this.addonsForModels.findIndex(a => a.id === id)
        if (index !== -1) {
          this.addonsForModels[index] = response.data
        }
        return response.data
      } catch (err) {
        this.error = err
        throw err
      } finally {
        this.loading = false
      }
    },

    async deleteAddonForModel(id) {
      this.loading = true
      this.error = null
      try {
        await apiService.post(`/addons-for-model-delete/${id}`)
        this.addonsForModels = this.addonsForModels.filter(a => a.id !== id)
      } catch (err) {
        this.error = err
        throw err
      } finally {
        this.loading = false
      }
    },
  }
})
